export default ()=>({
    isLog: false,
    directory : [],
    personalContacts :{},
    records: {
        dicc: {
            records: []
        },
        num_pages: 1,
        page_number: 1,
    },
    callRecords:[],
    totalCallRecords: 0,
    loading: false,
    noResults: false,
    personalVoiceMail: [],
    voiceMailCount: 0,
    voiceMailTotalCount: 0,
    voiceMailTotalPages: 1,
    conferences: {
        conferences: []
    },
    userSettings: [],
    meetings: [],
    meetingsCount:0,
    defaultMeeting: {
        page: 0,
        itemsPerPage: 5,
        mutation1: "setMeetings",
        mutation2: "setCountMeetings",
        entity: "meetings",
    },
    meetingLink: "",
    alertMessage: "",
    showSnackbar: false,
    snackbarMessage: "",
    videosMeet: [],
    previewView: {
        show: false,
        img: null,
        link: null,
        type: null,
    },
    detailChat: {
        show: false,
        data: null,
    },
    detailChatJoin: {
        show: false,
        data: null,
    },
    detailChatFexIA: {
        show: false,
        data: null,
    },
    msgModal: {
        show: false,
        color: 'green',
        title: '',
        content: null,
        loading: false,
        task: null,
        confirmBtn: false,
    },
    contactModal: {
        show: false,
        hasNumber: false,
        contactExist: false,
    },
    drive: {
        files: [],
        filesCount: 0,
        loading: false,
        indexFolder: 0,
        arrayFolder: [],
        // NEW!
        // index de carpeta
        currentDirectory: null,
        protected: false,
        // obj de carpeta
        currentFolder: null,
        fileCount: 0,
        totalSize: 0,
        tableRows: [],
        path: [
            {
                name: 'Home',
                id: null,
                disabled: false,
            },
        ],
        recordTranscription: {},
        chatsAllFiles: [],
        chatsSubfolders: [],
        chatsActiveSubfolder: null,
    },
})
